
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = new Map();
function $18c11f3350a906ea$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$18c11f3350a906ea$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

parcelRegister("cG0YX", function(module, exports) {
module.exports = new URL("ETH.923ee116.svg", import.meta.url).toString();

});

parcelRegister("04xqS", function(module, exports) {
module.exports = new URL("MATIC.39438b8c.svg", import.meta.url).toString();

});

parcelRegister("cvbAi", function(module, exports) {
module.exports = new URL("USDC.ab65008b.svg", import.meta.url).toString();

});

parcelRegister("IfNeQ", function(module, exports) {
module.exports = new URL("undefined.b51e8db5.svg", import.meta.url).toString();

});

var $663cfc5b4180bc0f$exports = {};

(parcelRequire("27Lyk")).register(new URL("", import.meta.url).toString(), JSON.parse("[\"4pNqu\",\"index.1449360e.js\",\"9Wf7v\",\"etherscan-logo-circle.141e2e71.svg\",\"aEii3\",\"ETH.923ee116.svg\",\"dZUjy\",\"MATIC.39438b8c.svg\",\"g6GZ3\",\"USDC.ab65008b.svg\",\"5Nhq2\",\"undefined.b51e8db5.svg\",\"eg4GK\",\"index.cbe3f578.js\"]"));


var $4dFYb = parcelRequire("4dFYb");

var $3LLrX = parcelRequire("3LLrX");

var $4sjDq = parcelRequire("4sjDq");

var $4bJvo = parcelRequire("4bJvo");

var $gnKYa = parcelRequire("gnKYa");

var $lGFPX = parcelRequire("lGFPX");

var $dwTAg = parcelRequire("dwTAg");

var $3cMgf = parcelRequire("3cMgf");

var $gwoQm = parcelRequire("gwoQm");

var $1dRRv = parcelRequire("1dRRv");
var $jxZic = parcelRequire("jxZic");
var $7RlNJ = parcelRequire("7RlNJ");
var $9bf5a75311e011d4$exports = {};
$9bf5a75311e011d4$exports = new URL("etherscan-logo-circle.141e2e71.svg", import.meta.url).toString();


var $09c891e81b589353$var$decimals = {
    '0x0000000000000000000000000000000000000000': 18
};
var $09c891e81b589353$var$balances = {};
var $09c891e81b589353$var$compliantBalances = {};
var $09c891e81b589353$var$currency;
var $09c891e81b589353$var$whitelisted = false;
const $09c891e81b589353$var$defaultCurrencies = [
    'USDC',
    'RWA'
];
function $09c891e81b589353$var$auditLink(chainID, verificationReferenceID, display) {
    return `<a href="#" onClick="AuditRequest=window.open('https://app.securely.id/audit/?chain-id=${chainID}&verification-reference-id=${verificationReferenceID}','AuditRequest','width=450,height=560'); return false;">${display}</a>`;
}




function $09c891e81b589353$var$updateCurrencyIcon(currency) {
    switch(currency){
        case 'ETH':
            $('.currency-icon').attr('src', (parcelRequire("cG0YX")));
            break;
        case 'MATIC':
            $('.currency-icon').attr('src', (parcelRequire("04xqS")));
            break;
        case 'USDC':
            $('.currency-icon').attr('src', (parcelRequire("cvbAi")));
            break;
        default:
            $('.currency-icon').attr('src', (parcelRequire("IfNeQ")));
            break;
    }
}
async function $09c891e81b589353$var$templateInjection() {
    $09c891e81b589353$var$updateLink();
    // Fetch the base informations
    console.log('Fetching base informations...');
    const signer = await (0, $3cMgf.getSigner)();
    $('#wallet-address').html((0, $dwTAg.prettyAddress)(signer.address));
    const readonlyProvider = await (0, $3cMgf.getReadonlyProvider)();
    const chainId = await (0, $3cMgf.getChainId)();
    const etherscan = (0, $lGFPX.addresses)[chainId].getAddress('etherscan');
    const dappAddress = (0, $lGFPX.addresses)[chainId].getAddress('compliantTreasury');
    $('#dapp-contract-address').html(`<a href="${etherscan}/address/${dappAddress}">${dappAddress}</a>`);
    $('#policies-explorer-link').attr('href', `https://dashboard.securely.id/explorer/?chainid=${chainId}&address=${dappAddress}`);
    const compliantTreasury = new $1dRRv.Contract(dappAddress, (0, $4sjDq.CompliantTreasuryAbi), readonlyProvider);
    const complianceAddress = await compliantTreasury.compliance();
    $('#compliance-contract-address').html(`<a href="${etherscan}/address/${complianceAddress}">${complianceAddress}</a>`);
    const compliance = new $1dRRv.Contract(complianceAddress, (0, $3LLrX.ComplianceAbi), readonlyProvider);
    try {
        const whitelistedRole = await compliantTreasury.WHITELISTED_ROLE();
        $09c891e81b589353$var$whitelisted = await compliantTreasury.hasRole(whitelistedRole, signer.address);
    } catch (error) {
        console.warn('Failed to check whitelisted role:', error.message);
    }
    if ($09c891e81b589353$var$whitelisted) {
        $('#principal-title').text('Compliant');
        $('#superficial-title').text('Unverified');
        $('#deposit-block').hide();
        $('#payment-link-label').text('Share this link:');
    } else {
        $('#principal-title').text('My Vault');
        $('#superficial-title').text('Connected Wallet');
        $('#superficial-col').hide();
        $('#principal-col').removeClass('col-8').addClass('col-12');
        $('#payment-link-label').text('Want someone else to deposit? Share this link:');
    }
    // Display the compliance details
    const controllers = await (0, $4bJvo.getControllers)(compliance);
    const controllersLineBreak = Object.keys(controllers).length > 1 ? '<br />' : '';
    $('#compliance-controllers').empty();
    for(const controller in controllers)$('#compliance-controllers').append(`${controllersLineBreak}<a href="${etherscan}/address/${controller}">${controller}</a>`);
    // Build the movements in three steps: payments, withdrawals, and transfers
    console.log("Building movements...");
    const movements = [];
    // Step 1: payments
    console.log("Step 1: payments");
    const paymentsPromise = compliantTreasury.queryFilter(compliantTreasury.filters.Payment(null, signer.address));
    const payments = (await paymentsPromise).reverse();
    for (const payment of payments){
        const { source: source, destination: destination, currency: currency, amount: amount } = payment.args;
        payment.type = "payment";
        movements.push({
            blockNumber: payment.blockNumber,
            type: "payment",
            source: source,
            destination: destination,
            currency: currency,
            amount: amount,
            txHash: payment.transactionHash
        });
    }
    // Step 2: withdrawals
    console.log("Step 2: withdrawals");
    const withdrawalsPromise = compliantTreasury.queryFilter(compliantTreasury.filters.Withdrawal(signer.address));
    const withdrawals = await withdrawalsPromise;
    for (const withdrawal of withdrawals){
        const { account: account, currency: currency, amount: amount } = withdrawal.args;
        withdrawal.type = "withdrawal";
        movements.push({
            blockNumber: withdrawal.blockNumber,
            type: "withdrawal",
            source: account,
            destination: account,
            currency: currency,
            amount: amount,
            txHash: withdrawal.transactionHash
        });
    }
    // Step 3: transfers
    console.log("Step 3: transfers");
    // Create filters for transfers where either the first or the second argument is signer.address
    const transfersFromPromise = compliantTreasury.queryFilter(compliantTreasury.filters.Transfer(signer.address, null));
    const transfersFrom = await transfersFromPromise;
    const transfersToPromise = compliantTreasury.queryFilter(compliantTreasury.filters.Transfer(null, signer.address));
    const transfersTo = await transfersToPromise;
    // Combine the results from both filters
    const transfers = [
        ...transfersFrom,
        ...transfersTo
    ];
    // Remove duplicates if any
    const uniqueTransfers = Array.from(new Set(transfers.map((t)=>t.transactionHash))).map((hash)=>transfers.find((t)=>t.transactionHash === hash));
    for (const transfer of uniqueTransfers){
        const { source: source, destination: destination, currency: currency, amount: amount } = transfer.args;
        movements.push({
            blockNumber: transfer.blockNumber,
            type: "transfer",
            source: source,
            destination: destination,
            currency: currency,
            amount: amount,
            txHash: transfer.transactionHash
        });
    }
    // Build the default balances
    console.log("Building default balances...");
    $09c891e81b589353$var$balances = {
        '0x0000000000000000000000000000000000000000': await signer.provider.getBalance(signer.address)
    };
    $09c891e81b589353$var$compliantBalances = {
        '0x0000000000000000000000000000000000000000': await compliantTreasury.balanceOf(signer.address, $7RlNJ.ZeroAddress)
    };
    for (let prettyCurrency of $09c891e81b589353$var$defaultCurrencies){
        const currency = (0, $lGFPX.addresses)[chainId].getAddress(prettyCurrency);
        const erc201 = new $1dRRv.Contract(currency, (0, $gnKYa.Erc20Abi), readonlyProvider);
        try {
            $09c891e81b589353$var$decimals[currency] = await erc201.decimals();
        } catch (error) {
            console.warn('Failed to get decimals (defaulting to 18):', error.message);
            $09c891e81b589353$var$decimals[currency] = 18;
        }
        try {
            $09c891e81b589353$var$balances[currency] = await erc201.balanceOf(signer.address);
            $09c891e81b589353$var$compliantBalances[currency] = await compliantTreasury.balanceOf(signer.address, currency);
        } catch (error) {
            console.warn(`Failed to get balance for ${prettyCurrency} (defaulting to 0):`, error.message);
            $09c891e81b589353$var$balances[currency] = BigInt(0);
            $09c891e81b589353$var$compliantBalances[currency] = BigInt(0);
        }
    }
    console.log("decimals", $09c891e81b589353$var$decimals);
    console.log("Building balances...");
    for (const movement of movements){
        if ($09c891e81b589353$var$decimals[movement.currency] === undefined) {
            const erc201 = new $1dRRv.Contract(movement.currency, (0, $gnKYa.Erc20Abi), readonlyProvider);
            try {
                $09c891e81b589353$var$decimals[movement.currency] = await erc201.decimals();
            } catch (error) {
                console.warn('Failed to get decimals (defaulting to 18):', error.message);
                $09c891e81b589353$var$decimals[movement.currency] = 18;
            }
        }
        if ($09c891e81b589353$var$balances[movement.currency] === undefined) try {
            $09c891e81b589353$var$balances[movement.currency] = await erc20.balanceOf(signer.address);
        } catch (error) {
            console.warn(`Failed to get balance for ${movement.currency} (defaulting to 0):`, error.message);
            $09c891e81b589353$var$balances[movement.currency] = BigInt(0);
        }
        if ($09c891e81b589353$var$compliantBalances[movement.currency] === undefined) try {
            $09c891e81b589353$var$compliantBalances[movement.currency] = await compliantTreasury.balanceOf(signer.address, movement.currency);
        } catch (error) {
            console.warn(`Failed to get compliant balance for ${movement.currency} (defaulting to 0):`, error.message);
            $09c891e81b589353$var$compliantBalances[movement.currency] = BigInt(0);
        }
    }
    // Display the balances table
    console.log("Displaying balances...");
    $('#balances').empty();
    $('#balances-details').empty();
    for(let token in $09c891e81b589353$var$compliantBalances){
        var compliantBalance = $09c891e81b589353$var$compliantBalances[token];
        var unverifiedBalance = $09c891e81b589353$var$balances[token];
        if ($09c891e81b589353$var$whitelisted) {
            if (compliantBalance > $09c891e81b589353$var$balances[token]) compliantBalance = $09c891e81b589353$var$balances[token];
            unverifiedBalance -= compliantBalance;
        }
        const prettyCurrency = (0, $lGFPX.addresses)[chainId].getPrettyName(token, true, true, false);
        var prettyComplianceBalance = $jxZic.formatUnits(compliantBalance, $09c891e81b589353$var$decimals[token]);
        prettyComplianceBalance = (+prettyComplianceBalance).toFixed(4).replace(/\.0000$/, '');
        var prettyUnverifiedBalance = $jxZic.formatUnits(unverifiedBalance, $09c891e81b589353$var$decimals[token]);
        prettyUnverifiedBalance = (+prettyUnverifiedBalance).toFixed(4).replace(/\.0000$/, '');
        $('#balances').append(`<tr>
            <td>${prettyComplianceBalance}</td>
            <td>${prettyCurrency}</td>
            <td class="w-100"></td>
            <td class="nowrap">
                <a href="#" class="transfer" data-currency="${(0, $lGFPX.addresses)[chainId].getPrettyName(token, false)}" data-bs-toggle="modal" data-bs-target="#transferModal"><i class="fa-solid fa-upload"></i></a>
                &nbsp;&nbsp;
                <a href="#" class="receive" data-currency="${(0, $lGFPX.addresses)[chainId].getPrettyName(token, false)}" data-bs-toggle="modal" data-bs-target="#receiveModal"><i class="fa-solid fa-download"></i></a>
            </td>
        </tr>`);
        $('#balances-details').append(`<tr>
            <td class="w-50"></td>
            <td class="superficial">${prettyUnverifiedBalance}</td>
            <td class="superficial">${prettyCurrency}</td>
            <td class="w-50"></td>
        </tr>`);
    }
    $('.transfer').on('click', function() {
        $09c891e81b589353$var$prepareTransfer($(this).data('currency'));
    });
    $('.receive').on('click', function() {
        $09c891e81b589353$var$prepareReceive($(this).data('currency'));
    });
    // Check if the approvals column should be displayed
    console.log("Checking approvals...");
    const approvalsPromise = compliance.queryFilter(compliance.filters.ApprovalRequired(dappAddress));
    const approvals = (await approvalsPromise).reverse();
    if (approvals.length > 0) $('#approvals-column').show();
    // Build & display the payment history table
    console.log("Building payment history...");
    const sortedMovements = movements.sort((a, b)=>b.blockNumber - a.blockNumber);
    $('#payment-history').empty();
    for (const movement of sortedMovements){
        const { blockNumber: blockNumber, type: type, source: source, destination: destination, currency: currency, amount: amount, txHash: txHash } = movement;
        const receipt = await readonlyProvider.getTransactionReceipt(txHash);
        const complianceEvents = receipt.logs.map((log)=>{
            try {
                return compliance.interface.parseLog(log);
            } catch (e) {
                return null;
            }
        }).filter((event)=>event && event.name == "ComplianceConsumed");
        if (complianceEvents.length == 0) {
            console.warn(`No ComplianceConsumed event found for ${txHash}`);
            continue;
        }
        const complianceDetails = complianceEvents[0].args.complianceDetails;
        const complianceFullHash = complianceEvents[0].args.fullHash;
        const comData = JSON.parse(complianceDetails);
        const timestamp = (await readonlyProvider.getBlock(blockNumber)).timestamp;
        var richArgs = `
            <!--Compliance hash: ${$09c891e81b589353$var$auditLink(chainId, complianceFullHash)}<br />-->
            <!--Transaction hash: ${txHash}<br />-->
        `;
        for (const comSubData of comData)richArgs += `<span data-bs-toggle="tooltip" data-bs-title="Ref: ${comSubData.ref}" data-bs-placement="top">
                ${$09c891e81b589353$var$auditLink(chainId, comSubData.ref, `${comSubData.type} (${comSubData.providerName})`)}
                </span><br />`;
        var approvalDate = 'Automatic';
        if (approvals.length > 0) {
            const approvalVerdicts = await compliance.queryFilter(compliance.filters.ComplianceVerdict(dappAddress, complianceFullHash));
            if (approvalVerdicts.length > 0) {
                const approvalTimestamp = (await readonlyProvider.getBlock(approvalVerdicts[0].blockNumber)).timestamp;
                approvalDate = (0, $gwoQm.formatTimestamp)(Number(approvalTimestamp));
            }
        }
        const color = source == signer.address && type != 'payment' ? '#B00000' : 'green';
        const sign = source == signer.address && type != 'payment' ? '-' : '+';
        const prettyAmount = $jxZic.formatUnits(amount, $09c891e81b589353$var$decimals[currency]).replace(/\.0$/, '');
        const prettyCurrency = (0, $lGFPX.addresses)[chainId].getPrettyName(currency);
        var action;
        if (type == 'payment' && source == signer.address) action = 'deposited';
        else if (type == 'payment') action = 'payed by';
        else if (type == 'withdrawal') action = 'withdrawn';
        else if (type == 'transfer' && source == signer.address && destination == signer.address) continue;
        else if (type == 'transfer' && source == signer.address) action = 'sent to';
        else if (type == 'transfer' && destination == signer.address) action = 'received from';
        const counterpart = action == 'deposited' || action == 'withdrawn' ? '' : (0, $dwTAg.prettyAddress)(destination == signer.address ? source : destination, true, false);
        const approval = approvals.length > 0 ? ` (approved ${approvalDate})` : '';
        $('#payment-history').append(`<tr>
            <td style="color: ${color}" class="nowrap">${sign}</td>
            <td style="color: ${color}" class="nowrap">${prettyAmount}</td>
            <td style="color: ${color}" class="nowrap">${prettyCurrency}</td>
            <td class="nowrap">${action}</td>
            <td class="nowrap"><b>${counterpart}</b></td>
            <td class="nowrap">${(0, $gwoQm.formatTimestamp)(Number(timestamp))}</td>
            <td class="nowrap">${approval}</td>
            <td class="nowrap"></td>
            <td class="nowrap">${richArgs}</td>
            <td class="nowrap"></td>
            <td class="nowrap">
                ${$09c891e81b589353$var$auditLink(chainId, txHash, '<i class="fa-solid fa-receipt" data-bs-toggle="tooltip" data-bs-html="true" data-bs-title="Request<br />compliance data" data-bs-placement="top"></i>')}&nbsp;
                <a href="${etherscan}/tx/${txHash}" target="_blank" data-bs-toggle="tooltip" data-bs-html="true" data-bs-title="View on<br />Etherscan">
                    <img height="20px" src="${$9bf5a75311e011d4$exports}" alt="View on Etherscan" />
                </a>
            </td>
        </tr>`);
    }
    // Refresh the UI elements
    (0, $gwoQm.refreshTooltips)();
    console.log("Template injection done");
}
function $09c891e81b589353$var$errorPopup(message) {
    console.error('Error:', message);
    $('#error-toast-body').text(message);
    new bootstrap.Toast($('#error-toast')).show();
    $('#pay-button').prop('disabled', false);
    $('#pay-button').html('Pay');
}
function $09c891e81b589353$var$warningPopup(message) {
    console.warn('Warning:', message);
    $('#warning-toast-body').text(message);
    new bootstrap.Toast($('#warning-toast')).show();
    $('#pay-button').prop('disabled', false);
    $('#pay-button').html('Pay');
}
function $09c891e81b589353$var$successPopup(message) {
    console.info('Success:', message);
    $('#success-toast-body').text(message);
    new bootstrap.Toast($('#success-toast')).show();
}
function $09c891e81b589353$var$prepareTransfer(prettyCurrency) {
    $09c891e81b589353$var$currency = prettyCurrency;
    console.log('Transfer:', $09c891e81b589353$var$currency);
    $09c891e81b589353$var$updateCurrencyIcon($09c891e81b589353$var$currency);
    $('.currency').text((0, $dwTAg.prettyAddress)($09c891e81b589353$var$currency, false, false));
    $('#transfer-amount-input').val('');
    $('#transfer-recipient-input').val('');
}
function $09c891e81b589353$var$prepareReceive(prettyCurrency) {
    $09c891e81b589353$var$currency = prettyCurrency;
    console.log('Receive:', $09c891e81b589353$var$currency);
    $09c891e81b589353$var$updateCurrencyIcon($09c891e81b589353$var$currency);
    $09c891e81b589353$var$updateLink();
    $('.currency').text((0, $dwTAg.prettyAddress)($09c891e81b589353$var$currency, false, false));
    $('#receive-amount-input').val('');
}
async function $09c891e81b589353$var$transfer() {
    $('#transfer-button').prop('disabled', true);
    $('#transfer-button').html((0, $gwoQm.loadingSpinner));
    const signer = await (0, $3cMgf.getSigner)();
    const chainId = (await signer.provider.getNetwork()).chainId;
    const compliantTreasuryAddress = (0, $lGFPX.addresses)[chainId].getAddress('compliantTreasury');
    const compliantTreasury = new $1dRRv.Contract(compliantTreasuryAddress, (0, $4sjDq.CompliantTreasuryAbi), signer);
    const currencyAddress = (0, $lGFPX.addresses)[chainId].getAddress($09c891e81b589353$var$currency);
    try {
        const amount = $jxZic.parseUnits($('#transfer-amount-input').val(), $09c891e81b589353$var$decimals[currencyAddress]);
        const recipient = $('#invoicer-input').val();
        const args = [
            recipient,
            currencyAddress,
            amount
        ];
        if ($09c891e81b589353$var$whitelisted) {
            if ($09c891e81b589353$var$currency != 'ETH') {
                const token = new $1dRRv.Contract(currencyAddress, (0, $gnKYa.Erc20Abi), signer);
                await token.approve(compliantTreasuryAddress, amount);
            }
            const value = $09c891e81b589353$var$currency == 'ETH' ? amount : BigInt(0);
            await (await compliantTreasury.transfer(...args, {
                value: value
            })).wait();
        } else if (recipient == signer.address) {
            const withdrawArgs = [
                currencyAddress,
                amount
            ];
            // const functionSelector = compliantTreasury.interface.getFunction('withdraw', withdrawArgs).selector;
            // or: = "function withdraw(address currency, uint256 amount) virtual public";
            await (0, $4dFYb.validateCompliance)(chainId, signer.address, compliantTreasuryAddress, 0, compliantTreasury.interface.encodeFunctionData('withdraw', withdrawArgs), // or: { functionSelector, withdrawArgs },
            {
                amounts: [
                    {
                        token: currencyAddress,
                        value: amount
                    }
                ]
            });
            await (await compliantTreasury.withdraw(...withdrawArgs)).wait();
            $09c891e81b589353$var$successPopup('Withdrawal completed.');
        } else {
            // const functionSelector = compliantTreasury.interface.getFunction('transfer', args).selector;
            // or: = "function transfer(address recipient, address currency, uint256 amount) virtual public";
            const response = await (0, $4dFYb.validateCompliance)(chainId, signer.address, compliantTreasuryAddress, 0, compliantTreasury.interface.encodeFunctionData('transfer', args), {
                wallets: [
                    recipient
                ],
                amounts: [
                    {
                        token: currencyAddress,
                        value: amount
                    }
                ]
            });
            console.log(response);
            if (response.result.status == "rejected") {
                console.log(response.result.reason);
                $09c891e81b589353$var$errorPopup(`Transfer rejected. ${response.result.reason}`);
            } else {
                try {
                    await (await compliantTreasury.transfer(...args)).wait();
                } catch (error) {
                    $09c891e81b589353$var$errorPopup(error.message);
                }
                const withdrawLink = `${window.location.origin}/withdraw?chain=${chainId}&currency=${$09c891e81b589353$var$currency}&amount=${$jxZic.formatUnits(amount, $09c891e81b589353$var$decimals[currencyAddress])}&sender=${signer.address}&recipient=${recipient}`;
                try {
                    navigator.clipboard.writeText(withdrawLink);
                    $09c891e81b589353$var$successPopup('Transfer completed.\nWithdraw link copied to clipboard.');
                } catch (error) {
                    $09c891e81b589353$var$warningPopup('Transfer completed.\nFailed to copy to clipboard: ' + error.message + '\nWithdraw link: ' + withdrawLink);
                }
            }
        }
    } catch (error) {
        $09c891e81b589353$var$errorPopup(error.message);
    }
    $('#transferModal').modal('hide');
    $('#transfer-button').prop('disabled', false);
    $('#transfer-button').html('Transfer');
    $09c891e81b589353$var$templateInjection();
}
async function $09c891e81b589353$var$deposit() {
    $('#deposit-button').prop('disabled', true);
    $('#deposit-button').html((0, $gwoQm.loadingSpinner));
    const signer = await (0, $3cMgf.getSigner)();
    const chainId = (await signer.provider.getNetwork()).chainId;
    const compliantTreasuryAddress = (0, $lGFPX.addresses)[chainId].getAddress('compliantTreasury');
    const compliantTreasury = new $1dRRv.Contract(compliantTreasuryAddress, (0, $4sjDq.CompliantTreasuryAbi), signer);
    const currencyAddress = (0, $lGFPX.addresses)[chainId].getAddress($09c891e81b589353$var$currency);
    try {
        const amount = $jxZic.parseUnits($('#receive-amount-input').val(), $09c891e81b589353$var$decimals[currencyAddress]);
        const value = $09c891e81b589353$var$currency == 'ETH' ? amount : BigInt(0);
        const args = [
            signer.address,
            currencyAddress,
            amount
        ];
        const functionSelector = compliantTreasury.interface.getFunction('pay', args).selector;
        // or: = "function pay(address destination, address currency, uint256 amount) virtual public payable";
        if ($09c891e81b589353$var$currency != 'ETH') {
            const token = new $1dRRv.Contract(currencyAddress, (0, $gnKYa.Erc20Abi), signer);
            await token.approve(compliantTreasuryAddress, amount);
        }
        const response = await (0, $4dFYb.validateCompliance)(chainId, signer.address, compliantTreasuryAddress, value, {
            functionSelector: functionSelector,
            args: args
        }, {
            amounts: [
                {
                    token: currencyAddress,
                    value: amount
                }
            ]
        });
        console.log(response);
        if (response.result.status == "rejected") {
            console.log(response.result.reason);
            $09c891e81b589353$var$errorPopup(`Transfer rejected. ${response.result.reason}`);
        } else {
            await (await compliantTreasury.pay(...args, {
                value: value
            })).wait();
            $09c891e81b589353$var$successPopup('Deposit completed.');
        }
    } catch (error) {
        console.error(error);
        $09c891e81b589353$var$errorPopup(error.message);
    }
    $('#receiveModal').modal('hide');
    $('#deposit-button').prop('disabled', false);
    $('#deposit-button').html('Deposit');
    $09c891e81b589353$var$templateInjection();
}
async function $09c891e81b589353$var$updateLink() {
    const invoicer = (await (0, $3cMgf.getSigner)()).address;
    const amount = $('#receive-amount-input').val();
    const invoicerVal = invoicer ? `receiver=${invoicer}` : '';
    const amountVal = amount ? `amount=${amount}` : '';
    const currencyVal = $09c891e81b589353$var$currency ? `currency=${$09c891e81b589353$var$currency}` : '';
    const args = [
        invoicerVal,
        amountVal,
        currencyVal
    ].filter((arg)=>arg).join('&');
    $('#payment-link').text(`${window.location.origin}/payment${args ? `?${args}` : ''}`);
}
function $09c891e81b589353$var$copyPaymentLink() {
    navigator.clipboard.writeText($('#payment-link').text());
    var paymentLinkControl = $('#payment-link-control').get(0);
    paymentLinkControl.style.transition = '';
    paymentLinkControl.style.setProperty('color', 'green', 'important');
    paymentLinkControl.style.opacity = '1';
    setTimeout(function() {
        paymentLinkControl.style.transition = 'color 1s, opacity 1s';
        paymentLinkControl.style.removeProperty('color');
        paymentLinkControl.style.opacity = '0.75';
    }, 50);
    setTimeout(function() {
        paymentLinkControl.style.transition = '';
    }, 600);
}
async function $09c891e81b589353$var$userPolicy() {
    const signer = await (0, $3cMgf.getSigner)();
    const chainId = (await signer.provider.getNetwork()).chainId;
    const compliantTreasuryAddress = (0, $lGFPX.addresses)[chainId].getAddress('compliantTreasury');
    (0, $4dFYb.validateUser)(chainId, compliantTreasuryAddress).then(function(response) {
        console.log(response);
        if (response.error) {
            $09c891e81b589353$var$errorPopup(`Service error: ${response.error.message}. Please try again later.`);
            return;
        }
        switch(response.result.status){
            case 'approved':
                $09c891e81b589353$var$successPopup('Your user profile is approved.');
                break;
            case 'approval_required':
                $09c891e81b589353$var$warningPopup('Your user profile requires approval to proceed, please try again later.');
                break;
            case 'rejected':
                $09c891e81b589353$var$errorPopup(`User profile rejected. ${response.result.reason}.`);
                break;
        }
    });
}
(0, $3cMgf.onWalletConnect)($09c891e81b589353$var$templateInjection);
$(document).ready(function() {
    window.userPolicy = $09c891e81b589353$var$userPolicy;
    window.setBackendUrl = (0, $4dFYb.setBackendUrl);
    window.setAuthUrl = (0, $4dFYb.setAuthUrl);
    window.setDevMode = (0, $4dFYb.setDevMode);
    $('#receive-amount-input').on('input', $09c891e81b589353$var$updateLink);
    $('#payment-link-control').click($09c891e81b589353$var$copyPaymentLink);
    $('#transfer-button').click($09c891e81b589353$var$transfer);
    $('#deposit-button').click($09c891e81b589353$var$deposit);
    $('#invoicer-button').click(async function() {
        const signer = await (0, $3cMgf.getSigner)();
        $('#invoicer-input').val(signer.address);
    });
    const searchParams = new URLSearchParams(window.location.search);
    const wallet = searchParams.has('wallet') ? searchParams.get('wallet') : 'metamask';
    (0, $3cMgf.providerInit)(wallet);
});


//# sourceMappingURL=index.1449360e.js.map
